import { render, staticRenderFns } from "./moreBtn.vue?vue&type=template&id=0166afdd&scoped=true&"
import script from "./moreBtn.vue?vue&type=script&lang=js&"
export * from "./moreBtn.vue?vue&type=script&lang=js&"
import style0 from "./moreBtn.vue?vue&type=style&index=0&id=0166afdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166afdd",
  null
  
)

export default component.exports